export enum TypographyColor {
  PRIMARY = "primary",
  SECONDARY = "secondary",
  ON_PRIMARY = "onPrimary",
  ON_INVERTED = "onInverted",
  FIXED_LIGHT = "fixedLight",
  FIXED_DARK = "fixedDark",
  INHERIT = "inherit"
}

export enum TypographyAlign {
  START = "start",
  CENTER = "center",
  END = "end"
}
